import { RootState } from '../../app/store';

export const selectAuthState = (state: RootState) => state.auth;
